import React, { memo } from "react";
import DataTable from "react-data-table-component";
import type { TableProps as DataTableProps } from "react-data-table-component";
import styles from "./Table.module.scss";
import { combineClasses } from "@/lib/utils";
import TableSkeleton from "./TableSkeleton";
import { useSelector } from "react-redux";

// Custom props that are NOT part of react-data-table's TableProps
interface CustomTableProps {
  className?: string;
}

// Combine DataTable's props with custom ones
type Props<T> = DataTableProps<T> & CustomTableProps;

  const customStyles = {
  table: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  tableWrapper: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  responsiveWrapper: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  noData: {
    style: {
      backgroundColor: 'var(--surface)',
      color: 'var(--text-2)',
    },
  },
  headRow: {
    style: {
      backgroundColor: 'var(--bg)',
      color: 'var(--text-3)',
      borderBottom: '1px solid var(--border)',
    },
  },
  rows: {
    style: {
      backgroundColor: 'var(--surface)',
      color: 'var(--text)',
      borderBottom: '1px solid var(--border-soft)',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'var(--surface-2)',
      color: 'var(--text)',
      outline: 'none',
      borderBottom: '1px solid var(--border-soft)',
    },
  },
  cells: {
    style: {
      color: 'var(--text)',
    },
  },
  pagination: {
    style: {
      backgroundColor: 'var(--surface)',
      color: 'var(--text)',
    },
  },
};

const Table = <T,>(props: Props<T>) => {
  const { sidebarOpen } = useSelector((state: any) => state.global);

  return (
    <div>
      <DataTable
        {...props}
        customStyles={customStyles}
        pagination={false}
        noDataComponent={
          <p className={styles.noData}>There are no records to display</p>
        }
        columns={props?.columns}
        className={combineClasses(
          "scrollable",
          styles.table,
          sidebarOpen ? styles.sidebarOpen : "",
          props.className || ""
        )}
        progressComponent={
          <TableSkeleton
            columns={props?.columns || []}
            sidebarOpen={sidebarOpen}
          />
        }
        fixedHeader={true}
        responsive
      />
    </div>
  );
};

export default memo(Table);
